import { purgeAnalyticsStorage } from './consent/purge.js';
import { getConsentSnapshot, subscribeConsent } from './consent/store.js';
const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js';
let measurementIdInUse = null;
let previous = null;
function setGaDisabled(measurementId, disabled) {
    window[`ga-disable-${measurementId}`] = disabled;
}
/** Inject gtag.js and configure the measurement ID — at most once per page. */
function loadGtag(measurementId) {
    if (document.querySelector(`script[src^="${GTAG_SRC}"]`))
        return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `${GTAG_SRC}?id=${measurementId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        // gtag.js only processes `arguments` objects; a rest-parameter array is silently ignored.
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
}
function applyConsent() {
    const consent = getConsentSnapshot();
    if (!measurementIdInUse || consent.status !== 'resolved')
        return;
    const prev = previous;
    previous = consent.effective;
    if (consent.effective === 'granted') {
        setGaDisabled(measurementIdInUse, false);
        loadGtag(measurementIdInUse);
        return;
    }
    setGaDisabled(measurementIdInUse, true);
    if (prev === 'granted')
        purgeAnalyticsStorage();
}
/**
 * Wire GA4 to the cookie-consent decision (BR-7, BR-8, NFR-PERF-1). The script loads only while
 * analytics are granted, and at most once per page; a revoke sets `ga-disable-<id>` and purges
 * `_ga*` cookies, and a re-grant clears the flag. Consent resolves synchronously from the cookie,
 * so gtag is never requested before it is known. No-ops if measurementId is falsy (e.g. dev).
 */
export function initGa4(measurementId) {
    if (!measurementId || typeof window === 'undefined' || measurementIdInUse)
        return;
    try {
        measurementIdInUse = measurementId;
        applyConsent();
        subscribeConsent(() => {
            try {
                applyConsent();
            }
            catch {
                // analytics must never throw
            }
        });
    }
    catch {
        // analytics must never throw
    }
}
export function trackSignupClick(location) {
    try {
        window.gtag?.('event', 'signup_clicked', {
            event_category: 'cta',
            event_label: location,
        });
    }
    catch {
        // analytics must never throw
    }
}
export function isGa4Enabled() {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
}
//# sourceMappingURL=ga.js.map